import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";

const Shimmer = () => {
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 6, md: 3 }}>
          <div class="card-shimmer loading">
            <div class="image"></div>
            <div class="content">
              <h1></h1>
              <h2></h2>
            </div>
          </div>
        </Grid>
   
      </Grid>
    </Container>
  );
};

export default Shimmer;
